import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=6d1ae71e&"
import script from "./CardContent.vue?vue&type=script&lang=js&"
export * from "./CardContent.vue?vue&type=script&lang=js&"
import style0 from "./CardContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports